import Form from '@/common/Form';
import { DateInputField } from '@/components/DateInput';
import { CombineRuleHistory } from '@/models/gen/graphql';
import { createNotification } from '@/utils';
import { Button, Col, InputGroup, Row } from 'react-bootstrap';
import { useState } from 'react';
import Toast from '@/models/Toast';
import { LoadingBlur } from '@/components/LoadingSpinner';
import { deleteCombineRuleHistoryBulk } from '../../api/services/combineRule/deleteCombineRuleHistoryBulk';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { NumberInputField } from '@/components/NumberInput';
import { InputField } from '@/components/Input';
import useConfirmation from '@/hooks/useConfirmation';

type CombineRuleHistoryItemProps = {
  data: Partial<CombineRuleHistory>;
  index: number;
  form: UseFormReturn<FieldValues, any, undefined>;
  endDate?: string;
};

const CombineRuleHistoryItem = ({ data, index, form, endDate }: CombineRuleHistoryItemProps) => {
  const [loading, setLoading] = useState(false);
  const confirmDelete = useConfirmation({});

  const handleDelete = async () => {
    try {
      await confirmDelete();
      try {
        setLoading(true);
        if (data.id) await deleteCombineRuleHistoryBulk([data.id]);
        const items = form.getValues('items');
        form.setValue('items', [...items.filter((_item, i) => i !== index)]);
      } catch {
        createNotification('Unable to delete discount. Please try again.', Toast.Type.DANGER, 'Delete Discount');
      } finally {
        setLoading(false);
      }
    } catch (err) {}
  };

  return (
    <Row className="CombineRuleHistory-Item">
      <Col>
        <div className="d-flex">
          <LoadingBlur loading={loading} />
          <div className="flex-grow-1 historyItemFields">
            <InputGroup className="w-100 px-3">
              <Form.Input
                as={NumberInputField}
                name={`items.${index}.discount`}
                label={`Discount ${index + 1}:`}
                placeholder="0"
                max="100"
              />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
            <InputGroup className="w-100 px-3">
              <Form.Watch name={`items.${index}.startDatetime`}>
                {([startDatetime = '']: [string], form) => (
                  <DateInputField
                    name={`items.${index}.startDatetime`}
                    label="Date Range"
                    className="w-100 calendar-input"
                    format="MMM DD, YYYY"
                    onChange={(selected: string): void => {
                      form.setValue(`items.${index}.startDatetime`, selected, { shouldValidate: true });
                    }}
                    value={[startDatetime]}
                  />
                )}
              </Form.Watch>
              <InputField name="endDate" className="w-100 calendar-input" value={endDate} readOnly />
            </InputGroup>
          </div>
          <Button variant="icon" onClick={handleDelete} className="d-flex flex-column justify-content-center deleteHistoryItemBtn">
            <i className="fa fa-trash" />
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default CombineRuleHistoryItem;
